import { Box, Button, Grid, Typography } from '@mui/material';
import { FeaturedProgramsIllustration } from '../../../../assets/illustration';
import { AppIcon } from '../../../../components/app-icon/AppIcon';
import { useFeaturedProgramsQuery } from '../../../../store/features/program/programSlice';
import { featuredProgramsStyles } from './styles';
import { FeaturedProgramsSlider } from './FeaturedProgramsSlider';
import { FeaturedProgramsSkeleton } from './FeaturedProgramsSkeleton';
import { FEATURED_FILTER_URL_PARAM } from '../../../../config/filter';
import { APP_URLS } from '../../../../routes/urls';
import { Link } from 'react-router-dom';

export const FeaturedPrograms: React.FC = () => {
  const { isError, isLoading, data: programs } = useFeaturedProgramsQuery();

  if (isError) return null;

  if (programs && programs.length === 0) return null;

  return (
    <Box className="container-fluid" sx={featuredProgramsStyles.container}>
      <Box sx={{ mb: 5 }}>
        <Grid
          container
          direction={{ xs: 'column-reverse', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'center', sm: 'flex-end' }}
          spacing={2.5}
        >
          <Grid item xs={12} sm alignSelf={{ xs: 'stretch', sm: 'flex-end' }}>
            <Grid container alignItems="flex-end" justifyContent="space-between">
              <Grid item>
                <Typography component="h2" color="common.white" variant="h3">
                  Explore our
                  <br />
                  <Typography variant="h3" component="span" color="primary" sx={{ bgcolor: 'warning.light' }}>
                    featured programs
                  </Typography>
                </Typography>
              </Grid>
              <Grid item sx={{ display: { xs: 'block', sm: 'none' } }}>
                <Button
                  sx={[featuredProgramsStyles.findMoreBtn]}
                  variant="default"
                  color="primary"
                  component={Link}
                  to={{ pathname: APP_URLS.programs, search: FEATURED_FILTER_URL_PARAM }}
                >
                  Find More
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <AppIcon sx={featuredProgramsStyles.illustration} Icon={FeaturedProgramsIllustration} role="presentation" />
            <Button
              sx={[featuredProgramsStyles.findMoreBtn, { display: { xs: 'none', sm: 'inline-flex' } }]}
              variant="default"
              color="primary"
              component={Link}
              to={{ pathname: APP_URLS.programs, search: FEATURED_FILTER_URL_PARAM }}
            >
              Find More
            </Button>
          </Grid>
        </Grid>
      </Box>
      {isLoading || !programs ? <FeaturedProgramsSkeleton /> : <FeaturedProgramsSlider programs={programs} />}
    </Box>
  );
};
